import { CustomColumnHeader, ID } from 'types';
import { checkSameId } from '@components/bid_request/details/utils/checkForChanges';

export const isVisibleToSuppliers = (headerId?: ID, headers?: CustomColumnHeader[]): boolean => (
  Boolean(headers?.find((header: CustomColumnHeader): boolean => (
    checkSameId(header?.id, headerId)
  ))?.is_supplier_visible)
);
